import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, InputBase, Radio, FormControlLabel, RadioGroup, Box } from '@material-ui/core';
import moment from 'moment';
import _ from 'lodash';
import * as Yup from 'yup';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { AddIcon, CheckIcon, DateIcon } from '../../../../components/Icon';
import Dialog from '../../../../components/Dialog';
import webDesign from '../../../../static/images/template.png';
import { i18n } from '../../../../language';
import { checkSubmitData } from '../TemplateEdit/list';
import { classNames, onKeyUpEnterOrSpace } from '../../../../utils';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    padding: '14.56% 0 15.828%',
    borderRadius: '0.375rem',
    border: '0.0625rem dashed #7d86a9',
    textTransform: 'inherit',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  icon: {
    fontSize: '1.125rem',
    color: theme.palette.font.sub,
  },
  context: {
    width: '100%',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.75rem',
    lineHeight: '1rem',
    color: theme.palette.font.sub,
    textAlign: 'center',
  },
  body: {
    display: 'inline',
    width: '100%',
  },
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
  },
  input: {
    borderRadius: '0.625rem',
    border: '0.0625rem solid #e4e7eb',
    backgroundColor: theme.palette.font.white,
    width: '100%',
    padding: '0 0 0 1.25rem',
    height: '3.5rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.font.main,
    margin: '0.625rem 0 0',
  },
  cardbody: {
    width: '18.688rem',
    height: '5.438rem',
    borderRadius: '0.9375rem',
    boxShadow: '0 0.25rem 0.75rem 0 rgba(0, 0, 0, 0.04)',
    border: '0.0625rem solid #e4e7eb',
    padding: '0 0 0 1.875rem',
    display: 'flex',
    alignItems: 'center',
    margin: '1.25rem 1.25rem 0 0',
    position: 'relative',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  cardimg: {
    width: '2.313rem',
    height: '3.25rem',
    marginRight: '1.25rem',
  },
  cardTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    color: theme.palette.font.main,
    fontWeight: 'bold',
  },
  dialogCardbody: {
    display: 'flex',
    flexWrap: 'wrap',
    '& >div:nth-child(2n+0)': {
      marginRight: '0',
    },
  },
  radioBody: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '6.25rem',
  },
  label: {
    margin: '0',
    width: '10.5rem',
    '& .MuiTypography-body1': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: theme.palette.font.main,
      fontWeight: '500',
    },
  },
  radio: {
    color: '#e4e7eb',
  },
  checkicon: {
    fontSize: '0.75rem',
    color: theme.palette.font.white,
    margin: '0 auto',
  },
  iconbody: {
    width: '1.5rem',
    height: '1.5rem',
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    right: '0.938rem',
  },
  cardchoose: {
    width: '18.688rem',
    height: '5.438rem',
    borderRadius: '0.9375rem',
    boxShadow: '0 0.25rem 0.75rem 0 rgba(0, 0, 0, 0.04)',
    border: '0.125rem solid #538fff',
    padding: '0 0 0 1.875rem',
    display: 'flex',
    alignItems: 'center',
    margin: '1.25rem 1.25rem 0 0',
    position: 'relative',
    backgroundColor: 'rgba(83, 143, 255, 0.1)',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  dialogBody: {
    overflowY: 'auto',
    width: '100%',
  },
  error: {
    borderColor: '#f44336 !important',
  },
  errorMsg: {
    margin: '3px 0.825rem 0 0.825rem',
    color: '#f44336',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    marginTop: '0.5rem',
  },
  dialogBodyDatePicker: {
    '& .MuiInputBase-root': {
      borderRadius: '0.625rem',
      border: '0.0625rem solid #E4E7EB',
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: theme.palette.font.main,
      fontWeight: 'normal',
      width: '11.938rem',
      height: '3rem',
    },
    '& .MuiButtonBase-root': {
      borderRadius: '0',
      padding: '0',
      '&:hover': {
        backgroundColor: theme.palette.font.white,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      display: 'none',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '0.75rem',
    },
  },
  Picon: {
    fontSize: '1.375rem',
    color: theme.palette.primary.main,
  },
  datePickerError: {
    '& .MuiInputBase-root': {
      borderColor: '#f44336 !important',
    },
  },
}));

function Card({ title, choose, formData, setFromData, dutyTemplateWardId, id }) {
  const classes = useStyles();

  function open() {
    return choose === dutyTemplateWardId;
  }

  function styleContrl() {
    return open() ? classes.cardchoose : classes.cardbody;
  }
  function iconContrl() {
    return open() ? (
      <div className={classes.iconbody}>
        <CheckIcon className={classes.checkicon} />
      </div>
    ) : null;
  }
  return (
    <div
      className={styleContrl()}
      onClick={() => {
        formData.choose = dutyTemplateWardId;
        setFromData({ ...formData });
      }}
      id={id}
      tabIndex={0}
      onKeyUp={(e) =>
        onKeyUpEnterOrSpace(e, () => {
          formData.choose = dutyTemplateWardId;
          setFromData({ ...formData });
        })
      }
    >
      <img className={classes.cardimg} src={webDesign} alt="" />
      <div className={classes.cardcontext}>
        <div className={classes.cardTitle}>{title}</div>
        <div className={classes.title}>{i18n.t('DUTYASSIGN_PLANNER_ADD_TEMPLATE')}</div>
      </div>
      {iconContrl()}
    </div>
  );
}

export default function AddCard({ time, createTemplateAPI, wardlist, roster, id }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});
  const listLength = _.filter(roster, (item) => {
    return item.date === time;
  }).length;

  useEffect(() => {
    setFromData({ ...formData, templates: wardlist });
  }, [wardlist]);

  const [formData, setFromData] = useState({
    title: '',
    templates: [],
    choose: '',
    cutomize: '2',
    dailyEndTime: null,
    weeklyEndTime: null,
  });

  const handleResetFormData = () => {
    setFromData({ ...formData, title: '', choose: '', cutomize: '2', dailyEndTime: null, weeklyEndTime: null });
  };

  const nameSchema = {
    title: Yup.string().required(
      i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('DUTYASSIGN_CHECK_TITLE') })
    ),
    dailyEndTime: Yup.string().required(
      i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('DUTYASSIGN_CHECK_TITLE') })
    ),
    weeklyEndTime: Yup.string().required(
      i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('DUTYASSIGN_CHECK_TITLE') })
    ),
  };

  const focusCheck = (name, value) => {
    return async () => {
      try {
        await checkSubmitData(Yup.object().shape({ [name]: nameSchema[name] }), { [name]: value });
        setError((preError) => {
          return { ...preError, [name]: null };
        });
      } catch (e) {
        setError((preError) => {
          return { ...preError, ...e };
        });
      }
    };
  };

  const handleDate = (props, setValue) => {
    if (props?.['_i'] && props?.['_i']?.[9] === '_') {
      setValue(null);
      return;
    }
    setValue(props);
  };

  const handleEndTime = (props) => {
    switch (props) {
      case '0':
        return moment(formData.dailyEndTime).format('DD-MM-YYYY');
      case '1':
        return moment(formData.weeklyEndTime).format('DD-MM-YYYY');
      default:
        return moment(time, 'D/M/YYYY').format('DD-MM-YYYY');
    }
  };

  const diffDate = (props) => {
    const num = moment(moment(formData[props]).format('YYYY-MM-DD')).diff(
      moment(time, 'D/M/YYYY').format('YYYY-MM-DD'),
      'days'
    );
    return !(num > 0 && num < 366);
  };

  const handleVertify = () => {
    return (
      formData.title === '' ||
      formData.choose === '' ||
      (formData.cutomize === '1' && (!formData.weeklyEndTime || diffDate('weeklyEndTime'))) ||
      (formData.cutomize === '0' && (!formData.dailyEndTime || diffDate('dailyEndTime')))
    );
  };

  return (
    <>
      <div
        className={classes.root}
        onClick={() => {
          setOpen(true);
        }}
        id={id}
        tabIndex={0}
        onKeyUp={(e) =>
          onKeyUpEnterOrSpace(e, () => {
            setOpen(true);
          })
        }
      >
        <div className={classes.body}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '0.563rem' }}>
            <AddIcon className={classes.icon} />
          </div>
          <Typography className={classes.context}>{i18n.t('DUTYASSIGN_PLANNER_ADD_TEMPLATE')}</Typography>
        </div>
      </div>
      <Dialog
        open={open}
        title={i18n.t('DUTYASSIGN_PLANNER_ADD_TEMPLATE')}
        cancel={i18n.t('DUTYASSIGN_CANCEL')}
        confirm={i18n.t('DUTYASSIGN_CONFIRM')}
        cancelID="DutyAssign-div-aex-cancel"
        confirmID="DutyAssign-div-aex-confirm"
        closeID="DutyAssign-div-aex-close"
        dialogfootStyle={{ marginTop: '1rem' }}
        confirmStyle={{
          opacity: handleVertify() ? '0.5' : '1',
        }}
        handleCancel={() => {
          setError({});
          handleResetFormData();

          setOpen(false);
        }}
        id="DutyAssign-Dialog-aey"
        handleClose={() => {
          setError({});
          handleResetFormData();
          setOpen(false);
        }}
        handleConfirm={() => {
          (async () => {
            await focusCheck('title', formData.title)();
          })();
          if (formData.cutomize === '0') {
            (async () => {
              await focusCheck('dailyEndTime', formData.dailyEndTime)();
            })();
          }
          if (formData.cutomize === '1') {
            (async () => {
              await focusCheck('weeklyEndTime', formData.weeklyEndTime)();
            })();
          }

          if (handleVertify()) {
            return null;
          }
          createTemplateAPI({
            addTime: moment(time, 'D/M/YYYY').format('DD-MM-YYYY'),
            dayOffWeek: formData.cutomize,
            dutyTemplateWardId: formData.choose,
            rosterCode: formData.title,
            rosterName: formData.title,
            rosterOrder:
              listLength === 0
                ? 0
                : _.filter(_.orderBy(roster, ['rosterOrder'], ['asc']), (item) => {
                    return item.date === time;
                  })[listLength - 1]?.rosterOrder + 1,
            endTime: handleEndTime(formData.cutomize),
          });
          handleResetFormData();
          setOpen(false);
        }}
      >
        <div className={classes.dialogBody}>
          <div className={classes.title}>{i18n.t('DUTYASSIGN_PLANNER_ADD_TEMPLATE_ROSTER_TITLE')}</div>
          <InputBase
            className={error.title ? classNames(classes.input, classes.error) : classes.input}
            placeholder={i18n.t('DUTYASSIGN_PLANNER_ADD_TEMPLATE_ROSTER_INPUT')}
            onChange={(event) => {
              if (event.target.value.length > 60) {
                event.target.value = event.target.value.slice(0, 60);
              }
              formData.title = event.target.value;
              setFromData({ ...formData });
            }}
            id="DutyAssign-InputBase-aez"
            onBlur={() => {
              (async () => {
                await focusCheck('title', formData.title)();
              })();
            }}
          />
          {error.title && <div className={classes.errorMsg}>{error.title}</div>}
          <div className={classes.title} style={{ marginTop: '2.125rem' }}>
            {i18n.t('DUTYASSIGN_PLANNER_ADD_TEMPLATE_CHOOSE_TITLE')}
          </div>
          <div className={classes.dialogCardbody}>
            {formData.templates.map((item, index) => (
              <Card
                title={item.templateName}
                choose={formData.choose}
                id={`DutyAssign-Card-afa-${index}`}
                formData={formData}
                setFromData={setFromData}
                key={item.dutyTemplateWardId}
                dutyTemplateWardId={item.dutyTemplateWardId}
              />
            ))}
          </div>
          <div className={classes.title} style={{ marginTop: '1.875rem', marginBottom: '1.438rem' }}>
            {i18n.t('DUTYASSIGN_PLANNER_ADD_TEMPLATE_CUTOMIZE_TITLE')}
          </div>
          <RadioGroup
            className={classes.radioBody}
            row
            onChange={(event) => {
              setError((preError) => {
                return { ...preError, dailyEndTime: null, weeklyEndTime: null };
              });
              formData.cutomize = event.target.value;
              setFromData({ ...formData });
            }}
            defaultValue="2"
          >
            <Box display="flex">
              <FormControlLabel
                className={classes.label}
                value="0"
                control={<Radio className={classes.radio} color="primary" id="DutyAssign-RadioGroup-afb-0" />}
                label={i18n.t('DUTYASSIGN_PLANNER_ADD_TEMPLATE_DAILY')}
                labelPlacement="end"
                style={{ marginBottom: '1.75rem' }}
              />
              <KeyboardDatePicker
                className={
                  error?.dailyEndTime
                    ? classNames(classes.dialogBodyDatePicker, classes.datePickerError)
                    : classes.dialogBodyDatePicker
                }
                keyboardIcon={
                  <DateIcon
                    className={classes.Picon}
                    style={{ color: formData.cutomize === '0' ? '#538fff' : '#c0c6cb' }}
                  />
                }
                value={formData.dailyEndTime}
                onChange={(event) =>
                  handleDate(event, (props) =>
                    setFromData((preState) => {
                      return { ...preState, dailyEndTime: props };
                    })
                  )
                }
                id="DutyAssign-KeyboardDatePicker-afc"
                variant="dialog"
                format="DD-MM-yyyy"
                inputVariant="outlined"
                InputAdornmentProps={{ position: 'end' }}
                placeholder="Select end date"
                disabled={formData.cutomize !== '0'}
                minDate={moment(time, 'D/M/YYYY').add(1, 'd').format('YYYY-MM-DD')}
                maxDate={moment(time, 'D/M/YYYY').add(365, 'd').format('YYYY-MM-DD')}
                onBlur={() => {
                  (async () => {
                    await focusCheck('dailyEndTime', formData.dailyEndTime)();
                  })();
                }}
              />
            </Box>
            <Box display="flex">
              <FormControlLabel
                className={classes.label}
                value="1"
                control={<Radio className={classes.radio} color="primary" id="DutyAssign-RadioGroup-afb-1" />}
                label={i18n.t('DUTYASSIGN_PLANNER_ADD_TEMPLATE_WEEKLY')}
                style={{ marginBottom: '1.75rem' }}
                labelPlacement="end"
              />
              <KeyboardDatePicker
                className={
                  error?.weeklyEndTime
                    ? classNames(classes.dialogBodyDatePicker, classes.datePickerError)
                    : classes.dialogBodyDatePicker
                }
                keyboardIcon={
                  <DateIcon
                    className={classes.Picon}
                    style={{ color: formData.cutomize === '1' ? '#538fff' : '#c0c6cb' }}
                  />
                }
                value={formData.weeklyEndTime}
                onChange={(event) =>
                  handleDate(event, (props) =>
                    setFromData((preState) => {
                      return { ...preState, weeklyEndTime: props };
                    })
                  )
                }
                id="DutyAssign-KeyboardDatePicker-afd"
                variant="dialog"
                format="DD-MM-yyyy"
                inputVariant="outlined"
                disabled={formData.cutomize !== '1'}
                InputAdornmentProps={{ position: 'end' }}
                placeholder="Select end date"
                minDate={moment(time, 'D/M/YYYY').add(1, 'd').format('YYYY-MM-DD')}
                maxDate={moment(time, 'D/M/YYYY').add(365, 'd').format('YYYY-MM-DD')}
                onBlur={() => {
                  (async () => {
                    await focusCheck('weeklyEndTime', formData.weeklyEndTime)();
                  })();
                }}
              />
            </Box>
            <FormControlLabel
              className={classes.label}
              value="2"
              control={<Radio className={classes.radio} color="primary" id="DutyAssign-RadioGroup-afb-2" />}
              label={i18n.t('DUTYASSIGN_PLANNER_ADD_TEMPLATE_NONE')}
              labelPlacement="end"
            />
          </RadioGroup>
        </div>
        <div style={{ borderBottom: '0.0625rem solid #e4e7eb' }} />
      </Dialog>
    </>
  );
}
